import { isRecordEmpty } from 'hx-util';
import { useEffect } from 'react';
import { useDominantSpeaker } from './useRoom/useDominantSpeaker';
import { useParticipant, } from './useRoom/useParticipant';
import { useRoomConnection, } from './useRoom/useRoomConnection';
import { useToggleCamera, } from './useRoom/useToggleCamera';
import { useToggleMicrophone, } from './useRoom/useToggleMicrophone';
export var useRoom = function (_a) {
    var _b = _a === void 0 ? {} : _a, onDisconnected = _b.onDisconnected, onConnected = _b.onConnected, voiceOnly = _b.voiceOnly;
    var _c = useRoomConnection({
        onDisconnected: onDisconnected,
        onConnected: onConnected,
    }), room = _c.room, error = _c.error, connectRoom = _c.connectRoom, disconnectRoom = _c.disconnectRoom;
    var _d = useParticipant({ room: room }), localParticipant = _d.localParticipant, remoteParticipants = _d.remoteParticipants;
    var dominantSpeaker = useDominantSpeaker({ room: room }).dominantSpeaker;
    var _e = useToggleCamera({
        room: room,
        initialState: !voiceOnly,
    }), isCameraOn = _e.isCameraOn, toggleCamera = _e.toggleCamera;
    var _f = useToggleMicrophone({
        room: room,
        initialState: true,
    }), isMicrophoneOn = _f.isMicrophoneOn, toggleMicrophone = _f.toggleMicrophone;
    useEffect(function () {
        if (isRecordEmpty(room))
            return;
        if (voiceOnly)
            toggleCamera(false);
    }, [voiceOnly, room]);
    return {
        room: room,
        error: error,
        connectRoom: connectRoom,
        disconnectRoom: disconnectRoom,
        localParticipant: localParticipant,
        remoteParticipants: remoteParticipants,
        dominantSpeaker: dominantSpeaker,
        isCameraOn: isCameraOn,
        toggleCamera: toggleCamera,
        isMicrophoneOn: isMicrophoneOn,
        toggleMicrophone: toggleMicrophone,
    };
};
